"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IntlProvider_1 = require("./IntlProvider");
exports.IntlProvider = IntlProvider_1.default;
var IntlService_1 = require("./IntlService");
exports.IntlService = IntlService_1.IntlService;
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-intl/dist/npm/Intl/main.js
// module id = 6605
// module chunks = 0